export enum MonitoringPanels {
	ROUTES,
	ROUTES_DETAILS,
	TIME_LINE,
	MAP
}

export const FULL_SCREEN = 100;
const FIXED_ROUTES_WIDTH = 15;
export const FULL_SECTION_WIDTH = FULL_SCREEN - FIXED_ROUTES_WIDTH;

export const defaultSizes = {
	[MonitoringPanels.ROUTES]: FIXED_ROUTES_WIDTH,
	[MonitoringPanels.ROUTES_DETAILS]: 0,
	[MonitoringPanels.TIME_LINE]: FULL_SECTION_WIDTH,
	[MonitoringPanels.MAP]: 0
};

export const calcSectionsSizes = (sizes: number[], panel: MonitoringPanels, collapse: boolean): number[] => {
	let details = 0,
		timeline = 0,
		map = 0;
	const routesSize =
		sizes[MonitoringPanels.ROUTES] !== 100 ? sizes[MonitoringPanels.ROUTES] : defaultSizes[MonitoringPanels.ROUTES];
	const fullWidth = 100 - routesSize;
	const halfWidth = fullWidth / 2;

	const isSectionClose = (index: MonitoringPanels) => sizes[index] === 0;

	if (panel === MonitoringPanels.ROUTES_DETAILS) {
		if (collapse) {
			if (isSectionClose(MonitoringPanels.MAP)) {
				timeline = fullWidth;
			} else if (isSectionClose(MonitoringPanels.TIME_LINE)) {
				map = fullWidth;
			} else {
				timeline = halfWidth;
				map = halfWidth;
			}
		} else {
			if (isSectionClose(MonitoringPanels.TIME_LINE) && isSectionClose(MonitoringPanels.MAP)) {
				details = fullWidth;
			} else if (isSectionClose(MonitoringPanels.TIME_LINE)) {
				details = halfWidth;
				map = halfWidth;
			} else {
				details = halfWidth;
				timeline = halfWidth;
			}
		}
	}

	if (panel === MonitoringPanels.TIME_LINE) {
		if (collapse) {
			if (isSectionClose(MonitoringPanels.ROUTES_DETAILS)) {
				map = fullWidth;
			} else {
				details = halfWidth;
				map = halfWidth;
			}
		} else {
			if (isSectionClose(MonitoringPanels.MAP) && isSectionClose(MonitoringPanels.ROUTES_DETAILS)) {
				details = fullWidth;
			} else if (isSectionClose(MonitoringPanels.MAP)) {
				details = halfWidth;
				timeline = halfWidth;
			} else {
				timeline = halfWidth;
				map = halfWidth;
			}
		}
	}

	if (panel === MonitoringPanels.MAP) {
		if (collapse) {
			if (isSectionClose(MonitoringPanels.ROUTES_DETAILS)) {
				timeline = fullWidth;
			} else if (isSectionClose(MonitoringPanels.TIME_LINE)) {
				details = fullWidth;
			} else {
				details = halfWidth;
				timeline = halfWidth;
			}
		} else {
			if (isSectionClose(MonitoringPanels.TIME_LINE) && isSectionClose(MonitoringPanels.ROUTES_DETAILS)) {
				map = fullWidth;
			} else {
				timeline = halfWidth;
				map = halfWidth;
			}
		}
	}

	return [routesSize, details, timeline, map];
};
